/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Nothreads1Inputs */

const zh_sidebar_nothreads1 = /** @type {(inputs: Sidebar_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无对话`)
};

const en_sidebar_nothreads1 = /** @type {(inputs: Sidebar_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations`)
};

const es_sidebar_nothreads1 = /** @type {(inputs: Sidebar_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conversaciones`)
};

/**
* | output |
* | --- |
* | "No conversations" |
*
* @param {Sidebar_Nothreads1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_nothreads1 = /** @type {((inputs?: Sidebar_Nothreads1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Nothreads1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_nothreads1(inputs)
	if (locale === "en") return en_sidebar_nothreads1(inputs)
	return es_sidebar_nothreads1(inputs)
});
export { sidebar_nothreads1 as "sidebar_noThreads" }